import { IconProps } from './types';

const ExpandIcon = (props: IconProps) => {
  const { width = '24', height = '24', fillColor = '#0276FE' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <mask
        id="mask0_787_45571"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width}
        height={height}
      >
        <rect width={width} height={height} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_787_45571)">
        <path
          d="M6.99976 17.0005H9.99976C10.2831 17.0005 10.5206 17.0963 10.7123 17.288C10.9039 17.4797 10.9998 17.7172 10.9998 18.0005C10.9998 18.2838 10.9039 18.5213 10.7123 18.713C10.5206 18.9047 10.2831 19.0005 9.99976 19.0005H5.99976C5.71642 19.0005 5.47892 18.9047 5.28726 18.713C5.09559 18.5213 4.99976 18.2838 4.99976 18.0005V14.0005C4.99976 13.7172 5.09559 13.4797 5.28726 13.288C5.47892 13.0963 5.71642 13.0005 5.99976 13.0005C6.28309 13.0005 6.52059 13.0963 6.71226 13.288C6.90392 13.4797 6.99976 13.7172 6.99976 14.0005V17.0005ZM16.9998 7.00049H13.9998C13.7164 7.00049 13.4789 6.90465 13.2873 6.71299C13.0956 6.52132 12.9998 6.28382 12.9998 6.00049C12.9998 5.71715 13.0956 5.47965 13.2873 5.28799C13.4789 5.09632 13.7164 5.00049 13.9998 5.00049H17.9998C18.2831 5.00049 18.5206 5.09632 18.7123 5.28799C18.9039 5.47965 18.9998 5.71715 18.9998 6.00049V10.0005C18.9998 10.2838 18.9039 10.5213 18.7123 10.713C18.5206 10.9047 18.2831 11.0005 17.9998 11.0005C17.7164 11.0005 17.4789 10.9047 17.2873 10.713C17.0956 10.5213 16.9998 10.2838 16.9998 10.0005V7.00049Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default ExpandIcon;
